import $ from "jquery";

// plugins

import "./plugins/xWindow";

// modules

// progressTracker

import "./modules/checkboxes";
import "./modules/countrySelect";
import "./modules/hcpOverlay";
import "./modules/overlay";
import "./modules/institution";
import "./modules/resourceTrigger";
import "./modules/reveal";
import "./modules/scroll";
import "./modules/pancakeNav";
import "./modules/selectSubmit";
import "./vendor/collapse";
import "./modules/slideProgress";
import "./modules/downloadProgress";

import CookieBanner from "./components/CookieBanner.vue";
import CookiePanel from "./components/CookiePanel.vue";

import { createApp } from "vue";

const app = createApp({
    mounted() {
        $.holdReady(false);
        const error = document.querySelector("[data-js-error]");
        if (error) {
            error.scrollIntoView();
        }
    },
});

app.component("cookie-banner", CookieBanner);
app.component("cookie-panel", CookiePanel);

app.mount("#app");
